import { render, staticRenderFns } from "./AdminBillings.vue?vue&type=template&id=600388d8&scoped=true"
import script from "./AdminBillings.vue?vue&type=script&lang=js"
export * from "./AdminBillings.vue?vue&type=script&lang=js"
import style0 from "./AdminBillings.vue?vue&type=style&index=0&id=600388d8&prod&lang=scss&scoped=true"
import style1 from "./AdminBillings.vue?vue&type=style&index=1&id=600388d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600388d8",
  null
  
)

export default component.exports